const types = {
  INDICATOR_COUNTRY_SET: 'indicatorTrendPreview/COUNTRY_SET',

  INDICATOR_DATA_LOAD_REQUEST: 'indicatorTrendPreview/LOAD_REQUEST',
  INDICATOR_DATA_LOAD_COMPLETED: 'indicatorTrendPreview/LOAD_COMPLETED',
  INDICATOR_DATA_LOAD_FAILED: 'indicatorTrendPreview/LOAD_FAILED',

  CLEAR: 'indicatorTrendPreview/DATA_CLEAR',
}

// const INTERVALS = [ 'DailyTrending', 'WeeklyTrending', 'MonthlyTrending', 'QuarterlyTrending', 'YearlyTrending' ];

// // simple ISO-week calculator (Mon = 1…Sun = 7)
// const isoWeekNumber = (d) => {
//   const target = new Date(d.valueOf());
//   const dayNr = (d.getDay()+6) % 7;
//   target.setDate(target.getDate() - dayNr + 3);
//   const jan4 = new Date(target.getFullYear(), 0, 4);

//   return 1 + Math.round((target - jan4) / 864e5 / 7);
// };
// const splitByPeriods = (key, rawData) => {
//   const idx = INTERVALS.indexOf(key);
  
//   if (idx === INTERVALS.length - 1) { return rawData; }

//   const { Data, Style, UnitRef } = rawData[key];
//   const entries = Object.entries(Data);
//   const base = { Style, UnitRef };
//   const result = {};
  
//   for (const [ymd, str] of entries) {
//     const year  = +ymd.slice(0, 4);
//     const month = +ymd.slice(4, 6);
//     const day   = +ymd.slice(6, 8);
//     const date  = new Date(year, month - 1, day);
//     const value = parseFloat(str);
    
//     for (let j = idx + 1; j < INTERVALS.length; j++) {
//       const interval = INTERVALS[j];

//       if (!result[interval]) { result[interval] = { ...base, Data: {} }; }

//       if (interval === 'WeeklyTrending') {
//         result[interval].Data[`${year}W${isoWeekNumber(date)}`] = value;
//       } else if (interval === 'MonthlyTrending') {
//         result[interval].Data[`${year}${String(month).padStart(2, '0')}`] = value;
//       } else if (interval === 'QuarterlyTrending') {
//         result[interval].Data[`${year}Q${Math.ceil(month / 3)}`] = value;
//       } else if (interval === 'YearlyTrending') {
//         result[interval].Data[`${year}`] = value;
//       }
//     }
//   }
  
//   return result;
// }

const initialState = { indicator: null };

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.INDICATOR_COUNTRY_SET:
        return { ...state, indicator: { ...state.indicator, country: action.country } };

    case types.INDICATOR_DATA_LOAD_REQUEST:

      return { ...state, indicator: { ...action.indicator, loading: true } };

    case types.INDICATOR_DATA_LOAD_COMPLETED:
      const responseData = { ...action.data };
      const indicatorData = responseData.data;      

      for (let i = 0; i < indicatorData.length; i++) {
        const item = indicatorData[i];
        const arrKey = Object.keys(item);
        // const rawKeys = Object.entries(item)
        //   .filter(([ subKey, subItem ]) => (
        //     INTERVALS.includes(subKey) && typeof subItem === 'object' && _size(subItem.Data) > 0
        //   ))
        //   .map(([ subKey ]) => (subKey));

        let result = {};
        
        for (let j = 0; j < arrKey.length; j++) {
          const key = arrKey[j];
          const value = item[key];

          if (typeof value !== 'object') { 
            item[key] = { Data: value } 
          // } else {
            // result = splitByPeriods(rawKeys[0], item);
          }
        }

        indicatorData[i] = { ...item, ...result };
      }
      
      return { ...state, indicator: { ...state.indicator, loading: false, ...responseData } };

    case types.INDICATOR_DATA_LOAD_FAILED:
      return { ...state, indicator: { ...state.indicator, loading: false } };

    case types.CLEAR:
      return { ...state, indicator: null };

    default:
      return state;
  }
}

const actions = {
  setIndicatorCountry: (country) => {
    return { type: types.INDICATOR_COUNTRY_SET, country: country };
  },
  loadIndicatorRequest: function(indicator) {
    return { type: types.INDICATOR_DATA_LOAD_REQUEST, indicator: indicator };
  },
  loadIndicatorCompleted: function(data) {
    return { type: types.INDICATOR_DATA_LOAD_COMPLETED, data: data };
  },
  loadIndicatorFailed: function(err) {
    return { type: types.INDICATOR_DATA_LOAD_FAILED, stock_error: err };
  },
  
  clearIndicatorData: function() { return { type: types.CLEAR }; },
};


export { types, actions }
